import { find, pick } from 'lodash'

import { Element, FlowState } from 'common/interfaces'

export function getFieldNames(elements: Element[], onlyRequired = false): string[] {
  const names: string[] = []

  elements?.forEach((element) => {
    if (element.children?.length > 0) {
      names.push(...getFieldNames(element.children, onlyRequired))
    }

    if (!onlyRequired || element.validations.required !== undefined) {
      names.push(element.name)
    }
  })

  return names
}

export function getClearData(
  dirtData: Record<string, any>,
  { pages }: FlowState,
  path: string[]
): Record<string, any> {
  return path.reduce((clear, pageId) => {
    const page = find(pages, { id: pageId })
    if (page !== undefined) {
      const { elements } = page

      const names = getFieldNames(elements)

      const values = pick(dirtData, names)

      const newClear: Record<string, any> = { ...clear, ...values }
      return newClear
    }

    return clear
  }, {})
}
